import React, { Component } from "react";
import PropTypes from "prop-types";

import GenericChartComponent from "../../GenericChartComponent";
import { getMouseCanvas } from "../../GenericComponent";

import { isDefined, noop, hexToRGBA } from "../../utils";

class ClickableCircle extends Component {
  constructor(props) {
    super(props);
    this.saveNode = this.saveNode.bind(this);
    this.renderSVG = this.renderSVG.bind(this);
    this.drawOnCanvas = this.drawOnCanvas.bind(this);
    this.isHover = this.isHover.bind(this);
  }
  saveNode(node) {
    this.node = node;
  }
  isHover(moreProps) {
    const { mouseXY } = moreProps;
    // const { r } = this.props;
    const r = this.props.r + 7;
    const [x, y] = helper(this.props, moreProps);

    const [mx, my] = mouseXY;
    const hover = x - r < mx && mx < x + r && y - r < my && my < y + r;

    // console.log("hover->", hover);
    return hover;
  }
  drawOnCanvas(ctx, moreProps) {
    const { stroke, strokeWidth, fill } = this.props;
    const { fillOpacity, strokeOpacity } = this.props;
    const { r } = this.props;

    const [x, y] = helper(this.props, moreProps);

    // Support both string color and registry-style color objects
    const extractColor = (val) => {
      if (typeof val === "string") return val;
      if (val && typeof val === "object") return val.color || val.value || "";
      return "";
    };

    const fillColor = extractColor(fill);
    const strokeColor = extractColor(stroke);

    ctx.lineWidth = strokeWidth;
    ctx.fillStyle = hexToRGBA(fillColor, fillOpacity);
    ctx.strokeStyle = hexToRGBA(strokeColor, strokeOpacity);

    ctx.beginPath();
    ctx.arc(x, y, r, 0, 2 * Math.PI, false);
    ctx.fill();
    ctx.stroke();
  }
  renderSVG(moreProps) {
    const { stroke, strokeWidth, fill } = this.props;
    const { fillOpacity, strokeOpacity } = this.props;
    const { r } = this.props;

    const [x, y] = helper(this.props, moreProps);

    const extractColor = (val) => {
      if (typeof val === "string") return val;
      if (val && typeof val === "object") return val.color || val.value || "";
      return "";
    };

    const fillColor = extractColor(fill);
    const strokeColor = extractColor(stroke);

    return (
      <circle
        cx={x}
        cy={y}
        r={r}
        strokeWidth={strokeWidth}
        stroke={strokeColor}
        strokeOpacity={strokeOpacity}
        fill={fillColor}
        fillOpacity={fillOpacity}
      />
    );
  }
  render() {
    const { interactiveCursorClass } = this.props;
    const { show } = this.props;
    const { onDragStart, onDrag, onDragComplete } = this.props;

    return show ? (
      <GenericChartComponent
        ref={this.saveNode}
        interactiveCursorClass={interactiveCursorClass}
        selected
        isHover={this.isHover}
        onDragStart={onDragStart}
        onDrag={onDrag}
        onDragComplete={onDragComplete}
        svgDraw={this.renderSVG}
        canvasDraw={this.drawOnCanvas}
        canvasToDraw={getMouseCanvas}
        drawOn={[
          "pan",
          "mousemove",
          "drag",
          "xAxisZoom",
          "yAxisReset",
          "yAxisZoomCommit",
          "resetYDomain",
        ]}
      />
    ) : null;
  }
}

function helper(props, moreProps) {
  const { xyProvider, cx, cy } = props;

  if (isDefined(xyProvider)) {
    return xyProvider(moreProps);
  }

  const {
    xScale,
    chartConfig: { yScale },
  } = moreProps;

  const x = xScale(cx);
  const y = yScale(cy);
  return [x, y];
}
ClickableCircle.propTypes = {
  xyProvider: PropTypes.func,

  onDragStart: PropTypes.func.isRequired,
  onDrag: PropTypes.func.isRequired,
  onDragComplete: PropTypes.func.isRequired,
  strokeWidth: PropTypes.number.isRequired,
  stroke: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      color: PropTypes.string,
      dash: PropTypes.string,
      width: PropTypes.number,
      opacity: PropTypes.number,
    }),
  ]).isRequired,
  fill: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      color: PropTypes.string,
      opacity: PropTypes.number,
    }),
  ]).isRequired,
  r: PropTypes.number.isRequired,

  cx: PropTypes.number,
  cy: PropTypes.number,

  className: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  strokeOpacity: PropTypes.number.isRequired,
  fillOpacity: PropTypes.number.isRequired,
  interactiveCursorClass: PropTypes.string,
};

ClickableCircle.defaultProps = {
  className: "react-stockcharts-interactive-line-edge",
  onDragStart: noop,
  onDrag: noop,
  onDragComplete: noop,
  onMove: noop,
  show: false,
  fillOpacity: 1,
  strokeOpacity: 1,
};

export default ClickableCircle;
